<template>
  <client-only>
    <v-flex id="cv-send-btn" text-left v-if="!IsExpired">
      <span v-if="!jobApplied">
        <v-btn
          class="cv_btn ma-0"
          @click="showDialog"
          :loading="isLoading"
          :class="[isExternalLink ? 'external-link' : 'inner-link']"
        >
          <span v-if="AllowNoCV">
            <img src="/tap.png" alt="TAP" width="12px" />
            {{ cvPopup.applyWithoutCv }}
          </span>
          <span v-else-if="isExternalLink">
            <img
              src="/send-cv-external.png"
              alt="TAP"
              width="27px"
              class="ml-1"
            />
            {{ cvBtnTxt }}
          </span>
          <span v-else>
            <img
              src="/send-cv-reg.png"
              alt="TAP"
              class="cv-send-icon"
            />
            {{ cvBtnTxt }}
          </span>
        </v-btn>
      </span>
      <CvDialog
        v-if="showCvDialog"
        :AllowNoCV="AllowNoCV"
        :open-dialog="showCvDialog"
        :FullName="FullName"
        :JobAnalytics="JobAnalytics"
        :Code="Code"
        :isJobOpen="isJobOpen"
        :isAA="isAA"
        :ExternalLink="ExternalLink"
        :ssasource="ssasource"
        :jobToLink="jobToLink"
        :jobCode="jobCode"
        :job-index="jobIndex"
        :IsRecommender="IsRecommender"
        :WhatFieldText="WhatFieldText"
        :currentPage="currentPage"
        :is-hitech="isHitech"
        :job-filters="jobFilters"
        :has-filters="hasFilters"
      />
    </v-flex>
  </client-only>
</template>

<script>
import CvDialog from '@/components/Dialogs/CvDialog/CvDialog';
import { t } from '@/store/modules/homeDrushim/constantsContent';
import gtm from '@/lib/gtm';
import CurrentUser from '@/components/mixins/CurrentUser';
import { mapGetters } from 'vuex';
import {
  STATISTICS_JOB_CLICK,
  STATISTICS_SEND_CV_EXTERNAL,
} from '@/lib/api.js';
import { get } from 'lodash';
import drushim_lodash from 'lodash';

export default {
  extends: [CurrentUser],
  components: {
    CvDialog,
  },
  props: {
    jobFilters: {
      type: Array,
      required: false,
      default: () => [],
    },
    hasFilters: {
      type: Boolean,
      required: false,
      default: false,
    },
    isHitech: {
      type: Boolean,
      required: false,
      default: false,
    },
    ssasource: {
      type: Number,
      required: false,
      default: 0,
    },
    isAA: {
      type: Boolean,
      required: false,
      default: false,
    },
    jobIndex: {
      type: Number,
      required: false,
      default: 0,
    },
    jobCode: {
      type: [Number, Object],
      required: false,
    },
    jobHash: {
      type: String,
      required: false,
    },
    cvLink: {
      type: String,
      required: true,
      default: '',
    },
    cvBtnTxt: {
      type: String,
      required: false,
      default: '',
    },

    isDisabled: {
      type: Boolean,
      required: false,

      default: false,
    },
    isJobOpen: {
      type: Boolean,
      required: false,
      default: false,
    },
    ExternalLink: {
      type: String,
      required: false,
      default: '',
    },
    IsExpired: {
      type: Boolean,
      required: false,
      default: false,
    },
    FullName: {
      type: String,
      required: false,
      default: '',
    },
    Code: {
      type: Number,
      required: false,
      default: 0,
    },
    JobAnalytics: {
      type: Object,
      required: false,
      default: () => {},
    },
    jobToLink: {
      type: Boolean,
      required: false,
      default: false,
    },
    AllowNoCV: {
      type: Boolean,
      required: false,
      default: false,
    },
    jobApplied: {
      type: Boolean,
      required: false,
      default: false,
    },
    IsRecommender: {
      type: Boolean,
      required: false,
      default: false,
    },
    /** relevant only for recommended jobs */
    currentPage: {
      type: String,
      required: false,
      default: '',
    },
    WhatFieldText: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      showCvDialog: false,
      isLoading: false,
      cvPopup: t('titles.CV_Popup'),
    };
  },

  mounted() {
    this.$bus.$on('closeDialog', this.closeDialog);
  },

  computed: {
    ...mapGetters(['isLogged']),
    ssa() {
      return get(this.$ssa, 'vm', {});
    },

    isExternalLink() {
      return !!this.ExternalLink;
    },

    externalLink() {
      return this.isExternalLink ? this.ExternalLink : '';
    },
  },
  beforeDestroy() {
    this.$bus.$off('closeDialog');
  },

  methods: {
    closeDialog() {
      this.showCvDialog = false;
    },
    sendSSA(eventName, jobcode, jobindex, ssasource) {
      this.ssa.log('LogSSA', {
        eventName: eventName,
        jobcode: jobcode,
        jobindex: jobindex,
        ssasource: ssasource,
      });
    },
    showAlert() {
      this.$bus.$emit(
        'showDialog',
        'כדי לשלוח קורות חיים למשרה זו יש לענות על דרישות החובה'
      );
    },
    /**
     * @param {Boolean} showCvDialog - will prop the value to the CvDialog
     */
    async showDialog() {
      this.isLoading = true;
      this.sendSSA(
        'ListingOAFClicked',
        this.jobCode,
        this.jobIndex,
        this.ssasource
      );

      this.fireGtm();
      /**
       * service event for statistics
       */
      try {
        this.$axios
          .get(`${STATISTICS_JOB_CLICK}/${this.jobCode}`, {
            withCredentials: true,
          })
          .then((res) => {
            if (res.data.IsError) {
              throw res.data.Errors;
            }
          });
      } catch (error) {
        error({ statusCode: 404, message: error });
      }

      /** Check if external link should be open or cv dialog
          @param {Boolean} this.jobToLink  prop from -> jobDetails.Company.Job2Link
          @param {Boolean} this.isLogged
       */
      if (this.isLogged && this.jobToLink) {
        try {
          await this.$axios
            .get(`${STATISTICS_SEND_CV_EXTERNAL}?jobcode=${this.jobCode}`)
            .then((res) => {
              if (res.data.IsError) {
                throw res.data.Errors;
              }

              /** redirect to external link
                 @param {URL} redirectTo
              */

              let redirectTo = res.data.RedirectTo;

              window.open(redirectTo);

              this.isLoading = false;
            });
        } catch (error) {
          error({ statusCode: 404, message: error });
        }
      } else {
        this.isLoading = false;
        this.showCvDialog = !this.showCvDialog;
      }
    },

    fireGtm() {
      if (this.IsRecommender) {
        const dataLayerJobClick = {
          category: 'recommender',
          action: 'job click',
          label: this.JobAnalytics.name, //job_name
          cd68: this.JobAnalytics.cd68, //IDjob
          cd69: this.JobAnalytics.cd69, //position
          cd70: this.currentPage,
          event: 'drushim_recommender',
        };
        const dataLayerRecommenderClick = {
          category: 'recommender',
          action: 'recommender click',
          cd70: this.currentPage,
          event: 'drushim_recommender',
          search: this.WhatFieldText,
        };
        gtm(dataLayerJobClick);
        gtm(dataLayerRecommenderClick);
      }

      const addToCartDataLayer = {
        event: 'addToCart',
        ecommerce: {
          currencyCode: 'ILS',
          add: {
            products: [
             drushim_lodash.pick(this.JobAnalytics, [
                'name',
                'id',
                'price',
                'brand',
                'category',
                'variant',
                'quantity',
                // 'coupon',
              ]),
            ],
          },
        },
      };
      const productClickDataLayer = {
        event: 'productClick',
        ecommerce: {
          currencyCode: 'ILS',
          click: {
            actionField: {
              list:drushim_lodash.get(this.JobAnalytics, 'list'),
            },
            products: [
             drushim_lodash.pick(this.JobAnalytics, [
                'name',
                'id',
                'price',
                'brand',
                'category',
                'variant',
                'quantity',
                // 'coupon',
              ]),
            ],
          },
        },
        'gtm.uniqueEventId': 544,
      };
      gtm(addToCartDataLayer);
      gtm(productClickDataLayer);
    },
  },
};
</script>
<style lang="scss" scoped>
.job-expired {
  text-align: center;
  color: #dd2c00;
  letter-spacing: normal;
}
.v-icon--right {
  margin: 0 !important;
}

.job-footer {
  border-top: 1px solid #ffffff;
}

.cv_btn {
  display: inline-flex;
  align-items: center;
  background-color: $send-cv-button !important;
  color: #ffffff !important;
  font-size: 14px;
  border-radius: 18px;
  height: 30px !important;
  padding: 0 15px 0 40px;
  margin-left: 22px;
  width: 170px;
}

.cv-send-icon {
  margin-left: 12px !important;
  font-size: 18px;
  width: 20px;
  vertical-align: middle;
}

.cv_btn:hover {
  background-color: #3e4a54 !important;
}

@media screen and (min-width: 600px) {
  .cv_btn {
    font-size: 18px;
    width: 205px;
    height: 35px;
  }
}

@media screen and (max-width: 350px) {
  .cv_btn {
    font-size: 11px;
  }
}
</style>
